import { Form } from "antd";
import ShopType from "@/enum/ShopType";
import React from "react";
import Input from "./BaseInput";
import ShopDTO from "@/dto/shop/ShopDTO";
import { SupplierShopTypes } from "@/utils/ShopUtils";
import AutoDismissToolTip from "@/components/AutoDismissToolTip";

interface PhoneFieldProps {
    shop: ShopDTO;
}

const hidePhoneShopTypes = [
    ShopType.PDD_FDS,
    ShopType.ALIBABA_SUPPLIER,
    ShopType.DOUDIAN_SUPPLIER,
    ShopType.YOUZAN,
    ...SupplierShopTypes,
];

const PhoneField: React.FC<PhoneFieldProps> = ({ shop }) => {
    if (hidePhoneShopTypes.includes(shop.type)) return null;

    let placeholder;

    if (
        [ShopType.CHANNEL_SHOP, ShopType.CHANNEL_SHOP_DROPSHIP, ShopType.CHANNEL_SHOP_SUPPLIER].includes(shop.type)
    ) {
        placeholder = "手机号后四位搜索";
    } else if (
        [
            ShopType.MOGUJIE,
            ShopType.WEIMOB_EC,
            ShopType.DUXIAODIAN,
            ShopType.AIKUCUN,
            ShopType.AIKUCUN_V2,
            ShopType.WEBUY,
        ].includes(shop.type)
    ) {
        placeholder = "完整手机号或后四位";
    } else {
        placeholder = "不能模糊搜索";
    }

    const el = (
        <Form.Item label={<span className="search-field-label">手机电话</span>} name="phone">
            <Input placeholder={placeholder} />
        </Form.Item>
    );

    if ([ShopType.PINDUODUO].includes(shop.type)) {
        return (
            <AutoDismissToolTip
                styles={{ body: { width: 310 } }}
                placement="top"
                title={
                    <p>
                        拼多多店铺支持输入隐私号+分机号搜索
                        <br />
                        例如1380000000-3211或1380000000[3211]
                    </p>
                }
                trigger="click"
            >
                {el}
            </AutoDismissToolTip>
        );
    }

    return el;
};

export default React.memo(PhoneField);
